module.exports = __webpack_public_path__ + "static/img/pinpai-8.87fa4273.png";